var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-end"},[_c('v-btn',{attrs:{"color":"primary","elevation":"0","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('next')}}},[_c('v-icon',[_vm._v("mdi-chevron-right")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }